// updateDB.js
import { supabase } from './supabase';

const updateDB = async (tableName, updates, idField, idValue) => {
  //console.log('Table Name:', tableName);
  //console.log('Updates:', updates);
  //console.log('ID Field:', idField);
  //console.log('ID Value:', idValue);
  try {
    const { data, error } = await supabase
      .from(tableName)
      .update(updates)
      .eq(idField, idValue);

    if (error) {
      //console.log(`Error updating ${tableName}:`, error);
    } else if (data) {
      //console.log("Successfully updated Table");
    }
  } catch (error) {
    console.error('Unexpected error:', error);
  }
};

export default updateDB;
